import { RetryPolicy, HttpClientDispenser } from '@vp/digital-http-client-lib';
import { getLibraryLoggingAttributes, getLogger } from '@vp/digital-logging-lib';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var name = "@vp/digital-care-lib";
var version = "0.20.11";

var getLibLogger = function (attributes) {
    var attr = getLibraryLoggingAttributes(name, version, attributes);
    return getLogger(attr);
};

var VISTAPRINT_TENANT = 'vistaprint';
var REQUESTOR = 'Digital';

var defaultConfig = {
    careChannelsApi: {
        baseUrl: 'https://channel-provider-service.care.vpsvc.com',
        operations: {
            getCareChannels: {
                timeoutMS: 3 * 1000,
                retry: {
                    policy: RetryPolicy.LinearBackOff,
                    count: 1,
                },
                cache: {
                    maxAgeMS: 60 * 1000,
                    maxSize: 1000,
                },
                parameters: {
                    requestor: 'Digital',
                },
            },
        },
    },
};

var careChannelsLogger = getLibLogger();
var apiConfig = defaultConfig.careChannelsApi;
var opConfig = apiConfig.operations.getCareChannels;
var careClientDispenser = new HttpClientDispenser(apiConfig, opConfig);
var isProduction = process.env.NODE_ENV === 'production';
var CARE_CHANNELS_URL_TIMEOUT = 30000;
function getCareChannels(locale, requestor) {
    if (requestor === void 0) { requestor = REQUESTOR; }
    return __awaiter(this, void 0, void 0, function () {
        var params, axiosConfig, careChannels, msg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = {
                        tenant: VISTAPRINT_TENANT,
                        locale: locale.toLowerCase(),
                        requestor: requestor,
                    };
                    careChannelsLogger.debug('getCareChannels: calling with parameters ', params);
                    axiosConfig = {
                        url: '/v2/channels',
                        method: 'get',
                        params: params,
                        timeout: CARE_CHANNELS_URL_TIMEOUT,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, careClientDispenser
                            .getInstance()
                            .request(axiosConfig)];
                case 2:
                    careChannels = (_a.sent()).data;
                    return [2, careChannels];
                case 3:
                    _a.sent();
                    msg = 'getCareChannels: Request to get care channels failed';
                    careChannelsLogger.error(msg, params);
                    if (isProduction) {
                        throw new Error(msg);
                    }
                    return [2, null];
                case 4: return [2];
            }
        });
    });
}

export { REQUESTOR, VISTAPRINT_TENANT, getCareChannels };
